import ApiService from "../services/ApiService";
import { wrapper } from "@/utils/wrapper";
import StorageService from "@/services/StorageService";

const apiService = new ApiService();
const storageService = new StorageService();

export async function openPage(
  page: string,
  patientsId: number
): Promise<number> {
  const request = await wrapper(apiService.openLoggerPage(page, patientsId));

  if (request.error) {
    console.error("Error openPage: ", request.error);
  }

  storageService.set("patientLoggerPageId", request.data.id);

  return request.data.id || undefined;
}

export async function closePage(loggerPageId: number, patientsId: number) {
  const request = await wrapper(
    apiService.closeLoggerPage(loggerPageId, patientsId)
  );

  if (request.error) {
    console.error("Error closePage: ", request.error);
  }

  storageService.delete("patientLoggerPageId");
}

export async function createAction(
  action: string,
  loggerPageId: number,
  module: number | undefined,
  page: number | undefined,
  patientsId: number
) {
  const request = await wrapper(
    apiService.createLoggerAction(patientsId, loggerPageId, {
      action: action,
      modulesId: module,
      pagesId: page
    })
  );

  if (request.error) {
    console.error("Error createAction: ", request.error);
  }
}
